import { Link } from 'react-router';

export function NotFound() {
  return (
    <div className="hero">
      <h1>404 Not Found</h1>
      <p>
        お探しのページは見つかりませんでした。<Link to="/">ホームへ戻る</Link>
      </p>
    </div>
  );
}
